import { InsuranceApplicationTypes } from "constants/billing";

interface TransitInsuranceBusinessValues {
  hasTransitInsuranceForSales: boolean;
  hasTransitInsuranceForPurchases: boolean;
}

const isNilOrFalse = (value: boolean): boolean =>
  value == null || value === false;

export const mapDefaultDeploymentTransitInsuranceToBusinessValues = (
  deploymentDefault: string,
): TransitInsuranceBusinessValues => {
  switch (deploymentDefault) {
    case InsuranceApplicationTypes.N_A:
      return {
        hasTransitInsuranceForSales: false,
        hasTransitInsuranceForPurchases: false,
      };
    case InsuranceApplicationTypes.SELL_ONLY:
      return {
        hasTransitInsuranceForSales: true,
        hasTransitInsuranceForPurchases: false,
      };
    case InsuranceApplicationTypes.BUY_AND_SELL:
      return {
        hasTransitInsuranceForSales: true,
        hasTransitInsuranceForPurchases: true,
      };
    case InsuranceApplicationTypes.BUY_ONLY:
      return {
        hasTransitInsuranceForSales: false,
        hasTransitInsuranceForPurchases: true,
      };
    default:
      return {
        hasTransitInsuranceForSales: false,
        hasTransitInsuranceForPurchases: false,
      };
  }
};

export const parseSideloadedTransitInsuranceValue = (
  value?: string | null,
): string | null | undefined => {
  const trimmedValue = value?.trim();

  if (!trimmedValue) {
    return null;
  }

  const normalizedValue = trimmedValue.toLowerCase().replace(/\s*\/\s*/g, "/");

  switch (normalizedValue) {
    case "sell":
      return InsuranceApplicationTypes.SELL_ONLY;
    case "buy":
      return InsuranceApplicationTypes.BUY_ONLY;
    case "buy/sell":
      return InsuranceApplicationTypes.BUY_AND_SELL;
    default:
      return undefined;
  }
};

export const buildTransitInsuranceFieldsFromSideLoadedBusinessValues = (
  value?: string | null,
): Record<string, boolean> => {
  const parsedValue = parseSideloadedTransitInsuranceValue(value);

  if (!parsedValue) {
    return {};
  }

  const insuranceValues =
    mapDefaultDeploymentTransitInsuranceToBusinessValues(parsedValue);

  return {
    hasTransitInsuranceForSales: insuranceValues.hasTransitInsuranceForSales,
    hasTransitInsuranceForPurchases:
      insuranceValues.hasTransitInsuranceForPurchases,
  };
};

export const mapBusinessValuesToInsuranceType = (
  business: Partial<
    Pick<
      Business,
      "hasTransitInsuranceForSales" | "hasTransitInsuranceForPurchases"
    >
  >,
): string | null => {
  switch (true) {
    case isNilOrFalse(business.hasTransitInsuranceForSales) &&
      isNilOrFalse(business.hasTransitInsuranceForPurchases):
      return InsuranceApplicationTypes.N_A;
    case business.hasTransitInsuranceForSales === true &&
      isNilOrFalse(business.hasTransitInsuranceForPurchases):
      return InsuranceApplicationTypes.SELL_ONLY;
    case business.hasTransitInsuranceForSales === true &&
      business.hasTransitInsuranceForPurchases === true:
      return InsuranceApplicationTypes.BUY_AND_SELL;
    case isNilOrFalse(business.hasTransitInsuranceForSales) &&
      business.hasTransitInsuranceForPurchases === true:
      return InsuranceApplicationTypes.BUY_ONLY;
    default:
      return null;
  }
};
